import Swiper from "swiper/bundle";
import "swiper/css/bundle";


export default class GoodsMain{
    
    constructor(){
        this._init();
    }


    _init(){
        this.itemUrl = location.href.indexOf('/goods/templates')>-1 ? './detail.html?item_id=' : './?item_id=';
        this.clicked = false;
        this._fetchContent();
    }


    _fetchContent(){
        const trigger = [...document.querySelectorAll(".js-fetch_open")];
        const close = [...document.querySelectorAll(".js-fetch_close")];

        trigger.forEach((el) => {

            el.addEventListener("click", () => {
                //連打防止
                if (this.clicked === true) return;
                this.clicked = true;

                const itemId = el.getAttribute("data-itemid");
                this._setContent(itemId);
            });
        });

        close.forEach((el) => {

            el.addEventListener("click", () => {
                this._removeContent();
            });
        });
    }

    _setContent(itemId){
        const url = this.itemUrl + itemId;
        const inner = document.querySelector(".js-fetch_content");

        fetch(url)
            .then((res) => res.text())
            .then((data) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(data, "text/html");
                const content = doc.querySelector(".goods__modal__main");
                inner.appendChild(content);
                this._setPrevNext();
                this._setSwiper();
            });
    }

    _setPrevNext(){

        [...document.querySelectorAll(".js-prevnext")].forEach($btn => {

            $btn.addEventListener("click", () => {
                this.clicked = false;
                const itemId = $btn.getAttribute("data-itemid");
                this._removeContent();
                this._setContent(itemId);
            });
        });
    }

    _setSwiper(){
        const thumb = document.querySelectorAll(".goods__modal__thumb__item");
        if(thumb.length <= 0) return;

        const firstactiveitem = document.querySelector('[data-swiper="0"]');
        firstactiveitem.classList.add("-active");

        const swiper = new Swiper(".goods__modal__swiper", {
            speed: 700,
            on: {
                beforeTransitionStart: e => {
                    const thumbs = document.querySelector(
                        ".goods__modal__thumb__item.-active"
                    );
                    thumbs.classList.remove("-active");

                    const activenum = e.activeIndex;
                    const activeitem = document.querySelector('[data-swiper="' + activenum + '" ]');
                    activeitem.classList.add("-active");
                }
            }
        });

        thumb.forEach((el) => {

            el.addEventListener("click", () => {
                const thumbnum = el.dataset.swiper;
                swiper.slideTo(thumbnum);
            });
        });
    }

    _removeContent() {
        const content = [...document.querySelectorAll(".goods__modal__main")];
        content.forEach((el) => el.remove());
        this.clicked = false;
    }
}